import { isArray } from 'util';
import { Brand } from '../brand';

export class BrandBuilder {
  static fromJson(json) {
    return (json)
      ? new Brand(
        json.hash,
        json.name,
        json.imagePath,
        json.bwImagePath
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(BrandBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/brand.builder.ts